import React, { useState, useEffect } from "react";
import { Cookie } from "lucide-react";
import { Button } from "./ui/button";

const BANNER_DELAY_MS = 800;
const STORAGE_KEY = "ozt_cookies";

const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // localStorage here only holds a non-sensitive cookie-consent flag ("accepted") — no user data.
    const accepted = localStorage.getItem(STORAGE_KEY);
    if (!accepted) {
      const t = setTimeout(() => setShow(true), BANNER_DELAY_MS);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, "accepted");
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 inset-x-4 sm:left-auto sm:right-6 sm:max-w-md z-[60] animate-fade-up">
      <div className="rounded-2xl bg-white shadow-2xl border border-slate-100 p-5">
        <div className="flex items-start gap-3">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
            <Cookie className="h-5 w-5" />
          </span>
          <div>
            <h4 className="font-display font-bold text-slate-900">This website uses cookies</h4>
            <p className="mt-1 text-sm text-slate-500 leading-relaxed">
              We use cookies to analyze website traffic and optimize your experience. By accepting, your data will be aggregated with all other user data.
            </p>
            <div className="mt-4 flex gap-2">
              <Button onClick={accept} className="rounded-lg bg-primary hover:bg-primary/90 text-sm">
                Accept
              </Button>
              <Button onClick={() => setShow(false)} variant="ghost" className="rounded-lg text-sm text-slate-600">
                Decline
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
